import script from "./LiveMonitorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveMonitorPage.vue?vue&type=script&setup=true&lang=js"

import "./LiveMonitorPage.vue?vue&type=style&index=0&id=126841c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126841c2"]])

export default __exports__